import {ShapeCommand} from '../commands.template';

export class FlowlineDeleteCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(data) {
    super(data);
    // this.firstAction = true;
  }

  public execute() {
    super.execute();

    const graph = this.services.editorRegistrySvc.getGraph();

    const line = this.services.graphHelperSvc
      .allFlowlines()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    graph.removeCells([line], false);

    return this.executeJson(this.object);
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteFlowline: {
        mxKey: Number(data.mxKey)
      }
    });
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const model = graph.getModel();
    let source = null;
    let target = null;

    if (this.object.srcId) {
      source = this.services.graphHelperSvc
        .allActivities()
        .concat(this.services.graphHelperSvc.allConnectorAndTerminators())
        .find(cell => Number(cell.id) === Number(this.object.srcId));
    }

    if (this.object.tgtId) {
      target = this.services.graphHelperSvc
        .allActivities()
        .concat(this.services.graphHelperSvc.allConnectorAndTerminators())
        .find(cell => Number(cell.id) === Number(this.object.tgtId));
    }

    model.beginUpdate();
    const flowline = this.services.shapeSpawnerSvc.createFlowline(this.object, source, target);

    flowline.skipUndo = true;
    this.services.shapeSpawnerSvc.updateFlowline(this.object, flowline, source, target);
    graph.addCell(flowline, this.services.graphHelperSvc.flowlineParent());

    this.reverseJson(this.object);

    model.endUpdate();
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      createFlowline: {
        mxKey: Number(data.mxKey),
        text: data.text,
        srcType: data.srcType,
        tgtType: data.tgtType,
        flForm: data.flForm,
        waypoints: data.waypoints,
        srcPosition: data.srcPosition,
        tgtPosition: data.tgtPosition,
        position: data.position,
        customStyle: data.customStyle,
        style: data.style,
        srcId: data.srcId,
        tgtId: data.tgtId,
        lineTexts: data.lineTexts
      }
    });
  }
}
